import {
    MANTLE_HELP_DESK_WIDGET_ID,
    MANTLE_HELP_DESK_SCRIPT_URL,
} from '../config';
import { sendMessage } from '../services/app.service';

let scriptLoadPromise: Promise<void> | null = null;
let isWidgetActive = false;
let syncChain = Promise.resolve();

const isBrowser = () => {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
};

const getHelpDeskWidget = () => {
    if (!isBrowser()) {
        console.log('isBrowser is false and Shopify is true');
        return undefined;
    }
    return (window as Window & { MantleHelpDeskWidget?: any }).MantleHelpDeskWidget;
};

const loadScript = () => {
    if (!isBrowser()) return Promise.resolve();

    try {
        const widget = getHelpDeskWidget();
        if (widget?.init) return Promise.resolve();
        if (scriptLoadPromise) return scriptLoadPromise;

        let scriptEl = document.querySelector(
            `script[src="${MANTLE_HELP_DESK_SCRIPT_URL}"]`
        );
        if (!scriptEl) {
            scriptEl = document.createElement('script');
            (scriptEl as any).src = MANTLE_HELP_DESK_SCRIPT_URL;
            (scriptEl as any).async = true;
        }
        if (!scriptEl.parentNode) {
            document.head.appendChild(scriptEl);
        }

        scriptLoadPromise = new Promise<void>((resolve, reject) => {
            try {
                if (getHelpDeskWidget()?.init) {
                    console.log('getHelpDeskWidget is true');
                    resolve();
                    return;
                }
                scriptEl.addEventListener('load', () => resolve(), { once: true });
                scriptEl.addEventListener(
                    'error',
                    () => reject(new Error('Mantle Help Desk script failed to load')),
                    { once: true }
                );
            } catch (err) {
                console.log('loadScript error', err);
                reject(err);
            }
        }).catch((err) => {
            scriptLoadPromise = null;
            console.log('loadScript error catch', err);
        });

        return scriptLoadPromise;
    } catch (err) {
        console.warn('Mantle Help Desk loadScript failed', err);
        return Promise.reject(err);
    }
};

const destroyWidgetBeforeRemount = async (widget: any) => {
    try {
        const canInspectState = typeof widget?.getState === 'function';
        if (!isWidgetActive && !canInspectState) {
            console.log('destroyWidgetBeforeRemount is false');
            return;
        }
        try {
            widget?.destroy?.();
        } catch (err) {
            console.log('destroyWidgetBeforeRemount error catch', err);
        }
        isWidgetActive = false;
        await new Promise((resolve) => requestAnimationFrame(resolve));
    } catch (err) {
        console.warn('Mantle Help Desk destroyWidgetBeforeRemount failed', err);
        isWidgetActive = false;
    }
};

const mountWidgetForShop = async (helpdeskJwt: string) => {
    try {
        const widget = getHelpDeskWidget();
        if (!widget?.init) {
            console.log('mountWidgetForShop widget.init is false');
            return;
        }

        await destroyWidgetBeforeRemount(widget);

        try {
            widget.init({
                widgetId: MANTLE_HELP_DESK_WIDGET_ID,
                theme: 'light',
                position: 'bottom-right',
                showDocs: true,
                showLogin: false,
            });
        } catch (err) {
            console.warn('Mantle Help Desk init failed', err);
            return;
        }

        if (helpdeskJwt) {
            try {
                widget.setJwt?.(helpdeskJwt);
            } catch (err) {
                console.warn('Mantle Help Desk setJwt failed', err);
            }
        } else {
            console.log('mountWidgetForShop helpdeskJwt is null');
        }

        isWidgetActive = true;
    } catch (err) {
        console.warn('Mantle Help Desk mountWidgetForShop failed', err);
    }
};

export const initMantleHelpDeskForContext = (helpdeskJwt: string) => {
    if (!MANTLE_HELP_DESK_WIDGET_ID) {
        console.log(
            'initMantleHelpDeskForContext MANTLE_HELP_DESK_WIDGET_ID is null'
        );
        return Promise.resolve();
    }

    const isInit=document.querySelector('#mantle-help-desk-widget-iframe');
    if(isInit) {
        console.log('initMantleHelpDeskForContext isInit is true');
        return Promise.resolve();
    }

    syncChain = syncChain
        .catch(() => { })
        .then(async () => {
            try {
                await loadScript();
                await mountWidgetForShop(helpdeskJwt);
            } catch (err) {
                console.log('initMantleHelpDeskForContext error catch', err);
            }
        });
    return syncChain;
};


export const mantleSendMessage = async (data: any) => {
    try {
        const response = await sendMessage(data);
        if(response?.ticketId && response.status) {
            getHelpDeskWidget()?.openChat?.({
                threadId: response?.ticket.id,
              });        
        }
        return response;
    } catch (err) {
        console.log('mantleSendMessage error', err);
        return null;
    }
};
  